<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="dialogForm" class="label-gray" label-width="100px" :rules="rules" ref="dialogForm">
      <template v-if="!dialogData.row">
        <el-form-item label="插件类型" prop="type">
          <el-select v-model="dialogForm.type">
            <el-option v-for="(item, index) in pluginType" :key="index" :label="item.msg" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="硬件平台" prop="checkPlatform">
          <el-select v-model="dialogForm.checkPlatform" multiple filterable allow-create placeholder="请选择或输入，按回车键确认" clearable default-first-option>
            <el-option v-for="(item, index) in platformType" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="插件版本" prop="sversion">
          <el-input v-model.trim="dialogForm.sversion" clearable></el-input>
        </el-form-item>
        <el-form-item label="插件文件" prop="file">
          <upload-file v-model="dialogForm.file" suffix="wpk"/>
        </el-form-item>
        <el-form-item label="内核版本" prop="kversion">
          <el-select v-model="dialogForm.kversion" clearable>
            <el-option v-for="(item, index) in coreType" :key="index" :label="item.msg" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item label="状态" prop="status">
          <el-select v-model="dialogForm.status">
            <el-option v-for="(item, index) in pluginStatus" :key="index" :label="item.msg" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <el-form-item label="备注">
        <el-input v-model.trim="dialogForm.remark" clearable></el-input>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
  import {inputEmpty, changeEmpty, checkVersion} from '@utils/validate'
  import UploadFile from "@view/components/upload/UploadFile"
  import {pluginStatus,pluginType,platformType,coreType} from "@utils/formatList"
  export default {
    name: "PluginOperate",
    props: {dialogData: Object},
    components: {UploadFile},
    data() {
      return {
        pluginStatus,
        pluginType,
        platformType,
        coreType,
        dialogForm: {
          file: null,
          checkPlatform: [],
          sversion: "",
          type: "bill",
          status: "",
          remark: "",
          kversion: ""
        },
        rules: {
          file: [changeEmpty("插件文件")],
          checkPlatform: [{type: 'array', required: true, message: '请至少输入一个硬件平台', trigger: 'change'}],
          sversion: [inputEmpty("插件版本"),checkVersion()],
          type: [inputEmpty("插件类型")],
        },
      }
    },
    created() {
      let row = this.dialogData.row;
      if (row) {
        Object.keys(this.dialogForm).forEach(key => this.dialogForm[key] = this.showData(key, row, ""));
        delete this.dialogForm.file;
        delete this.dialogForm.checkPlatform;
        delete this.dialogForm.sversion;
        delete this.dialogForm.type;
      } else {
        delete this.dialogForm.status;
      }
    },
    methods: {
      confirm() {
        let row = this.dialogData.row;
        row ? this.revise(row) : this.add();
      },
      dealData(nv) {
        if (nv.checkPlatform) {
          nv.platform = nv.checkPlatform.join(",");
          delete nv.checkPlatform;
        }
      },
      add() {
        this.$refs["dialogForm"].validate(async isOk => {
          if (isOk) {
            let nv = {...this.dialogForm};
            this.dealData(nv);
            let res = await this.$Http.addPlugin(nv, {timeout: 2*60*1000}, true);
            if (res) {
              this.msgSuccess("上传成功");
              this.$emit("table-reload");
              this.dialogData.visible = false;
            }
          }
        });
      },
      revise(row) {
        let nv = {};
        for(let [key, val] of Object.entries(this.dialogForm)) {
          if (val !== this.showData(key, row, "")) {
            nv[key] = val;
          }
        }
        if (Object.keys(nv).length) {
          this.$refs["dialogForm"].validate(isOk => {
            if (isOk) {
              this.openConfirm("修改该插件", async () => {
                nv.optionId = row.id;
                this.dealData(nv);
                let res = await this.$Http.revisePlugin(nv);
                if (res) {
                  this.msgSuccess("修改成功");
                  this.$emit("table-reload");
                  this.dialogData.visible = false;
                }
              });
            }
          });
        } else {
          this.msgInfo("您尚未做任何修改")
        }
      },
    }
  }
</script>

<style scoped>

</style>
